module.exports = "<div ng-include=\"'/modals/sources/detail.box.html'\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./project/modals/sources/partials/detail.dropbox.html
// module id = 860
// module chunks = 3